export default __webpack_public_path__ + "static/media/reactsight.00c7f629.webp";